var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.9 106",
    style: {
      enableBackground: "new 0 0 122.9 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A1E3C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.9,106H9.6l0,0c-2.7,0-5.1-1.1-6.8-2.8C1.1,101.4,0,99,0,96.4l0,0V0h12.3v93.7h110.6V106L122.9,106z  M83.4,45.6h19.5c1,0,1.9,0.8,1.9,1.9V86c0,1-0.8,1.9-1.9,1.9H83.4c-1,0-1.9-0.8-1.9-1.9V47.5C81.5,46.5,82.3,45.6,83.4,45.6 L83.4,45.6z M25.4,22.1h19.5c1,0,1.9,0.9,1.9,1.9v62c0,1-0.8,1.9-1.9,1.9H25.4c-1,0-1.9-0.8-1.9-1.9V24 C23.5,22.9,24.3,22.1,25.4,22.1L25.4,22.1L25.4,22.1z M54.4,8.8h19.5c1,0,1.9,0.9,1.9,1.9V86c0,1-0.8,1.9-1.9,1.9H54.4 c-1,0-1.9-0.8-1.9-1.9V10.7C52.5,9.7,53.3,8.8,54.4,8.8L54.4,8.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnChartIcon);
export default __webpack_public_path__ + "static/media/column-chart-icon.97f6720bc8ecfc7a2a79c3fdfd88f624.svg";
export { ForwardRef as ReactComponent };